import { Amplitude } from '../Shared/amplitude';

export const initMediaLinks = () => {
	$('.media-links__link a').click((e) => {
		const isDeal = !!$('#deal-key').val();
		const eventName = isDeal ? 'Deal - Click link' : 'Project - Click link';

		Amplitude.logEvent(eventName, {
			'Project': $('#project-name').val(),
			'Link': e.target.getAttribute('href')
		});
	});
};